import React, { useContext } from 'react';
import { LocaleContext } from '../../locale-context';
const data = require('./scholarshipData.json'); // JSON dosyasını bu şekilde dışarıdan da alabilirsin
export const translations = {
  tr: {
    city: 'İl',
    university: 'Üniversite',
    faculty: 'Fakülte',
    department: 'Bölüm',
    year: 'Yıl',
    scholarshipStudents: 'Burs Alan Öğrenciler',
  },
  en: {
    city: 'City',
    university: 'University',
    faculty: 'Faculty',
    department: 'Department',
    year: 'Year',
    scholarshipStudents: 'Scholarship Students',
  },
  ru: {
    city: 'Город',
    university: 'Университет',
    faculty: 'Факультет',
    department: 'Отделение',
    year: 'Год',
    scholarshipStudents: 'Стипендиаты',
  },
  uz: {
    city: 'Shahar',
    university: 'Universitet',
    faculty: 'Fakultet',
    department: 'Bo‘lim',
    year: 'Yil',
    scholarshipStudents: 'Stipendiya Oluvchilar',
  },
  ar: {
    city: 'المدينة',
    university: 'الجامعة',
    faculty: 'الكلية',
    department: 'القسم',
    year: 'السنة',
    scholarshipStudents: 'الطلاب الحاصلون على المنحة',
  },
};

export default function ScholarshipTable() {
    return (
        <LocaleContext.Consumer>
            {(locale) => {
                const currentLang = locale || 'tr';
                const t = translations[currentLang] || translations.tr;

                return (
                    <div key={currentLang} className="scholarship-container">
                        {Object.entries(data).map(([year, students]) => (
                            <div key={year} className="scholarship-card data-card">
                                <div className="card-header">
                                    <h2>{year} {t.year}</h2>
                                    <span className="badge">{t.scholarshipStudents}</span>
                                </div>
                                <div className="table-responsive">
                                    <table className="modern-table">
                                        <thead>
                                            <tr>
                                                <th>{t.city}</th>
                                                <th>{t.university}</th>
                                                <th>{t.faculty}</th>
                                                <th>{t.department}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {students.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>{item.il}</td>
                                                    <td>{item.okul}</td>
                                                    <td>{item.fakulte}</td>
                                                    <td>{item.bolum || '-'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))}
                    </div>
                );
            }}
        </LocaleContext.Consumer>
    );
}

